module.exports = __webpack_public_path__ + "img/cangkuban.396d5058.png";